<template>
    <IconButton
        preset="copy"
        :icon-class="showSuccess ? 'fi-check copy-feedback__check' : iconClass"
        :class="buttonClass"
        :disabled="disabled"
        :tooltip="tooltip"
        :aria-label="tooltip"
        @click="handleClick"
    />
</template>

<script>
import IconButton from '@/components/IconButton.vue';

export default {
    name: 'CopyButton',
    components: {
        IconButton,
    },
    props: {
        iconClass: { type: String, default: 'fi-link' },
        copyText: { type: String, default: null },
        autoCopy: { type: Boolean, default: true },
        disabled: { type: Boolean, default: false },
        buttonClass: {
            type: [String, Array, Object],
            default: () => ['icon-btn', 'icon-btn-white'],
        },
        alertText: { type: String, default: '' },
        tooltip: { type: String, default: 'Copy to clipboard' },
    },
    emits: ['click', 'copied', 'copy-failed'],
    data() {
        return {
            showSuccess: false,
            timeoutId: null,
        };
    },
    methods: {
        async handleClick(event) {
            this.$emit('click', event);

            if (!this.autoCopy || !this.copyText) return;

            try {
                await navigator.clipboard.writeText(this.copyText);
                this.triggerSuccess();
                this.$emit('copied');
                if (this.alertText) {
                    this.$alertStore.pushSuccess(this.alertText);
                }
            } catch (error) {
                console.error('Failed to copy text', error);
                this.$emit('copy-failed', error);
            }
        },
        triggerSuccess() {
            this.showSuccess = true;
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(() => {
                this.showSuccess = false;
            }, 1000);
        },
        reset() {
            this.showSuccess = false;
            clearTimeout(this.timeoutId);
        },
    },
    beforeUnmount() {
        clearTimeout(this.timeoutId);
    },
};
</script>

<style scoped>
.copy-feedback__check {
    animation: copyFeedbackPulse 0.2s ease-in-out forwards;
}

@keyframes copyFeedbackPulse {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    70% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}
</style>
